import reducer from './reducer';
import {
  setPdfFiles,
  setPageRendered,
  setPagesForFile,
  resetPagesRendered,
  clearDocumentInteract,
} from './actionCreators';

const actions = {
  setPdfFiles,
  setPagesForFile,
  setPageRendered,
  resetPagesRendered,
  clearDocumentInteract,
} as const;

export default {
  reducer,
  actions,
};

export const $actions = { ...actions };
